import React from 'react';
import './NavBar.scss';
import CloseIcon from '../../../assets/images/close.svg';
import { Link, useNavigate } from 'react-router-dom';
const NavBar = () => {

    const navigate = useNavigate()
    return (
        <div className="staffListNavBar">
            <div className="leftContainer">
                <Link to="/list-of-employees">
                    <div className="closeIconWrapper">
                        <img src={CloseIcon} alt="close" />
                    </div>
                </Link>
            </div>

            <div className="rightContainer">
                <div onClick={() => { navigate("/list-of-employees") }} className="cancellation">취소</div>
                <div onClick={() => { navigate("/list-of-employees") }} className="nextButton">저장</div>
            </div>
        </div>
    );
};

export default NavBar;